// extracted by mini-css-extract-plugin
export default {"component_ig":"ShowProvidersSortButton__component_ig--ig-Gr7o8"};